<div class="container-content" fxLayout="column">
  <app-exam-table-filter></app-exam-table-filter>
  <app-exam-table></app-exam-table>
  <app-paginator
    [filter]="filter"
    [total]="total"
    (filterApply)="load()"
  ></app-paginator>
  <app-loading-indicator-full
    *ngIf="loading"
  ></app-loading-indicator-full>
</div>
